var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAskByzSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ask",
    clipPath: "url(#clip0_395_7838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.07692 13.8462C3.07692 14.2542 3.24801 14.6455 3.55256 14.934C3.85711 15.2225 4.27016 15.3846 4.70085 15.3846H14.4444L17.6923 18.4615V6.15385C17.6923 5.74582 17.5212 5.35451 17.2167 5.06599C16.9121 4.77747 16.4991 4.61539 16.0684 4.61539H4.70085C4.27016 4.61539 3.85711 4.77747 3.55256 5.06599C3.24801 5.35451 3.07692 5.74582 3.07692 6.15385V13.8462Z",
    stroke: "url(#paint0_linear_395_7838)",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6154 10.7692C14.6154 11.1772 14.4533 11.5686 14.1648 11.8571C13.8763 12.1456 13.4849 12.3077 13.0769 12.3077H3.84615L0.769226 15.3846V3.07691C0.769226 2.66889 0.931313 2.27757 1.21983 1.98906C1.50835 1.70054 1.89966 1.53845 2.30769 1.53845H13.0769C13.4849 1.53845 13.8763 1.70054 14.1648 1.98906C14.4533 2.27757 14.6154 2.66889 14.6154 3.07691V10.7692Z",
    fill: "white",
    stroke: "url(#paint1_linear_395_7838)",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_395_7838",
    x1: 17.6923,
    y1: 11.5385,
    x2: 3.07692,
    y2: 11.5385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06BCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_395_7838",
    x1: 0.769226,
    y1: 8.46153,
    x2: 14.6154,
    y2: 8.46153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06BCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004CFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_395_7838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18.4615,
    fill: "white",
    transform: "translate(0 0.769226)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskByzSelectedIcon);
export default __webpack_public_path__ + "static/media/AskByzSelectedIcon.1aa3ee68c3a17fd4da06c666f86b9215.svg";
export { ForwardRef as ReactComponent };